/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q6Inputs */

const et_faq_q6 = /** @type {(inputs: Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis vahe on tavalisel veebilehel ja konversioonile optimeeritud veebilehel?`)
};

const en_faq_q6 = /** @type {(inputs: Faq_Q6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between a regular website and a conversion-optimized website?`)
};

/**
* | output |
* | --- |
* | "What's the difference between a regular website and a conversion-optimized website?" |
*
* @param {Faq_Q6Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const faq_q6 = /** @type {((inputs?: Faq_Q6Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q6Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_faq_q6(inputs)
	return en_faq_q6(inputs)
});